import axios from "axios";

class LockerService {
  putTurnOnLocker(payload) {
    return axios.put(`account/2fa/turn-on/locker`, payload);
  }
  async get2faLocker() {
    return axios.get(`account/2fa/generate/locker`);
  }
  put2faTurnOffLocker(payload) {
    return axios.put(`account/2fa/turn-off/locker`, payload);
  }
  putLocker(payload) {
    return axios.put('company/locker', payload);
  }
  putAuthenticationMethods(payload) {
    return axios.put('company/locker_settings', payload);
  }
  getAccessLocker(page, pageSize, payload) {
    return axios.get(
      `report/vault-history?page=${page}&pageSize=${pageSize}${payload}`,
    );
  }
  postKeysGenerate() {
    return axios.post(`account/recovery_keys/generate/locker`)  
  }
  getTokenEmailLocker() {
    return axios.get(`account/new-locker-email-token`); 
  }
  getTokenSmsLocker() {
    return axios.get(`account/new-locker-sms-token`); 
  }
}

export default new LockerService();
